import {ISVG} from "../../common/Logo/Logo";

export interface IShape3Props extends Pick<ISVG, "fill"> {}

export const Shape3 = ({ fill }: IShape3Props) => {
    const _fill = fill ?? "white";

    return (
        <svg
            width="125"
            height="28"
            viewBox="0 0 125 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M65.0452 -85.5756C78.7906 -84.6099 91.7036 -80.3313 102.16 -71.4555C113.609 -61.7374 124.02 -49.6439 124.925 -34.7493C125.872 -19.1591 117.746 -4.70797 106.906 6.65006C95.704 18.3873 81.3615 28.3225 65.0452 27.992C48.9605 27.6661 36.3805 16.0989 24.8651 4.98788C13.1479 -6.31784 0.535515 -18.5678 0.0204914 -34.7493C-0.505238 -51.2672 9.14341 -66.8221 22.2534 -77.0695C34.1195 -86.3446 49.9583 -86.6356 65.0452 -85.5756Z"
                fill={_fill}
            />
        </svg>
    );
};
